/** Par de colores por hash del id (docs/08 §2): h = (h * 31 + charCode) >>> 0, h % 6. */
export function avatarIndex(id: string): number {
  let h = 0;
  for (const char of id) h = (h * 31 + char.charCodeAt(0)) >>> 0;
  return (h % 6) + 1;
}

/** Iniciales de las dos primeras palabras. */
export function initials(name: string): string {
  return name
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((word) => word.charAt(0).toUpperCase())
    .join('');
}

export function Avatar({ id, name }: { id: string; name: string }) {
  const n = avatarIndex(id);
  return (
    <span
      className="avatar"
      aria-hidden="true"
      style={{ background: `var(--avatar-${String(n)}-bg)`, color: `var(--avatar-${String(n)}-fg)` }}
    >
      {initials(name)}
    </span>
  );
}
